module.exports = __webpack_public_path__ + "img/overlay_landscape.ae676e78.svg";